import loginedApi from "../apis";
import { toast } from "react-toastify";
import { LOGIN_SUCCESS_ACTION, LOG_OUT_ACTION, UPDATE_LOGIN } from "./type";
import {
  ADMIN_USER,
  DOCTOR,
  INTERBRANCH_COORDINATOR,
  CLINIC_ADMIN,
} from "../constants/const";

import CryptoJS from "crypto-js";
var hashcode = CryptoJS.SHA256(
  process.env.REACT_APP_PREFIX +
    process.env.REACT_APP_TOKEN +
    process.env.REACT_APP_SECRETKEY
);
const qs = require("qs");
const publicIp = require("public-ip");
let IP = publicIp.v4();
const { detect } = require("detect-browser");
const browser = detect();

let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B");
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D");
} //replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

export const loginAction =
  ({
    loginType,
    userName,
    accessCountry,
    password,
    history,
    backupData,
    setDrSign,
    isMobile,
  }) =>
  async (dispatch) => {
    console.log("isMobile login action",isMobile)
    let resp = await loginedApi.post("getcountrycode", {
      token: hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: `GMT${formatTime}` },
      requestType: 1058,
    });
    const doctorCountryCode = resp.data.data;
    //Adding the loading variables data
    var hash = CryptoJS.SHA512("C2MD|" + password);
    // var hash = CryptoJS.SHA512(password);
    const res = await loginedApi.post("login", {
      token: hashcode.toString(),
      data: {
        isFromMobile: true,
        clinicId: "20",
        deviceId: "",
        appname: "C2MD Patient",
        hashPassword: hash.toString(CryptoJS.enc.Base64),
        password: hash.toString(),
        loginType: loginType,
        userName: userName,
        browserTimeZone: `GMT${formatTime}`,
        Ipaddress: doctorCountryCode.Ipaddress,
        useragent: userAgent,
        Browser: browser.name + " " + browser.version,
        Os: platform,
        currency: doctorCountryCode.currency,
        accessCountry: doctorCountryCode.Country,
      },
      requestType: 3,
    });

    if (res?.data?.data?.info) {
      return res.data.data;
    } else {
      
      if (
        res.data?.data?.userType === "Patient" ||
        res.data?.data?.userType === ADMIN_USER
      ) {
        if (backupData && backupData?.redirection) {
          localStorage.setItem("userData", JSON.stringify(res.data.data));
          dispatch({ type: LOGIN_SUCCESS_ACTION, payload: res.data.data });

          history.push(backupData?.redirection);
        } else if (history?.location?.state?.redirection) {
          localStorage.setItem("userData", JSON.stringify(res.data.data));
          dispatch({ type: LOGIN_SUCCESS_ACTION, payload: res.data.data });

          history.push(history?.location?.state?.redirection);
        } else {
          localStorage.setItem("userData", JSON.stringify(res.data.data));
          dispatch({ type: LOGIN_SUCCESS_ACTION, payload: res.data.data });

          history.push("/dashboard");
        }
      } else if (
        res.data?.data?.userType == DOCTOR ||
        res.data?.data?.userType == INTERBRANCH_COORDINATOR
      ) {
        if(isMobile)
        {
          return "Please contact admin person."
        }else
        {
          localStorage.setItem("userData", JSON.stringify(res.data.data));
        dispatch({ type: LOGIN_SUCCESS_ACTION, payload: res.data.data });

        history.push("/dashboard");
        }
        
      } else if (res.data?.data?.userType == CLINIC_ADMIN) {
        localStorage.setItem("userData", JSON.stringify(res.data.data));
        dispatch({ type: LOGIN_SUCCESS_ACTION, payload: res.data.data });

        history.push("/dashboard");
      } else {
        // history.push("/dashboard");
        // setDrSign(true)
      }
    }
    return res.data.data;
  };

export const checkUser =
  ({ type, searchkey }) =>
  async (dispatch) => {
    const clientDetailsLocal = JSON.parse(
      localStorage.getItem("ClinicDetails")
    );

    const response = await loginedApi.post("loginwithotp", {
      requestType: 15,
      token: hashcode.toString(),
      data: {
        type: type,
        searchKey: searchkey,
        clinicId:
          clientDetailsLocal.id != undefined
            ? clientDetailsLocal.id
            : process.env.REACT_APP_CLINIC_ID,
      },
    });

    if (response.status === 200) {
      return response.data && response.data;
    }
  };

export const logoutAction = (user, history) => async (dispatch) => {
  // dispatch({ type: LOG_OUT_ACTION });
  // localStorage.removeItem("userData");

  let userData = localStorage.getItem("userData");
  userData = JSON.parse(userData);
  let { userType, clinicId, userId } = userData;

  console.log(history);
  const response = await loginedApi.post("logout", {
    requestType: 4,
    token: hashcode.toString(),
    data: { userId },
  });

  console.log(response);

  if (response.data.data.info === "home.html") {
    history.push("/signin");
    dispatch({ type: LOG_OUT_ACTION });
    localStorage.removeItem("userData");
    return true;
  }
};

export const loginwithotp =
  ({
    loginType,
    userName,
    accessCountry,
    history,
    appoinment_form,
    backupData,
    isMobile,
  }) =>
  async (dispatch) => {
    console.log("loginwithotp", backupData);

    const res = await loginedApi.post("login", {
      token: hashcode.toString(),
      data: {
        isFromMobile: true,
        Ipaddress: IP,
        clinicId: "20",
        deviceId: "",
        browserTimeZone: `GMT${formatTime}`,
        appname: "C2MD Patient",
        Os: platform,
        hashPassword: "",
        useragent: userAgent,
        password: "",
        accessCountry: accessCountry,
        loginType: loginType,
        userName: userName,
        isotpverified: true,
        Browser: browser.name + " " + browser.version,
      },
      requestType: 3,
    });

    console.log('Raw API Response:', res);

    if (res.data.data.info) {
      toast.error("Invalid username or password !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } 
    else if(res.data?.data?.userType==="Doctor" && isMobile )
    {
      return "Please contact admin person."
    }
    
    else {
      dispatch({
        type: LOGIN_SUCCESS_ACTION,
        payload: res.data.data,
      });

      
      console.log(res.data?.data?.userType);
      if (res.data?.data?.userType == "Patient") {
        if (appoinment_form?.routing) {
          await localStorage.setItem("userData", JSON.stringify(res.data.data));
          let doctrId = localStorage.getItem("doctrID");

          history.push(`/bookAppointment/${doctrId}`);
        } else {
          await localStorage.setItem("userData", JSON.stringify(res.data.data));
          history.push("/dashboard");
        }
      } else if(res.data?.data?.userType==="Doctor" && isMobile )
      {
        return "Please contact admin person."
      }
      
      else {
        await localStorage.setItem("userData", JSON.stringify(res.data.data));
        history.push("/dashboard");
      }
      return {
        data: res.data,
        success: true
      };
    }
  };

export const loginWithGoogle =
  ({ Data, history, redirect,isMobile, appoinment_form }) =>
  async (dispatch) => {
    const res = await loginedApi.post("login", {
      token: hashcode.toString(),
      data: {
        isFromMobile: true,
        Ipaddress: IP,
        clinicId: "20",
        deviceId: "",
        browserTimeZone: `GMT${formatTime}`,
        appname: "C2MD Patient",
        Os: platform,
        hashPassword: "",
        useragent: userAgent,
        password: "",
        accessCountry: "IN",
        loginType: "email",
        userName: Data?.email,
        isotpverified: true,
        Browser: browser.name + " " + browser.version,
      },
      requestType: 3,
    });

    if (res.data.data.info) {
      return res.data.data;
    } else {
       if(res.data?.data?.userType==="Doctor" && isMobile )
    {
      return "Please contact admin person."
    }else{
      dispatch({ type: LOGIN_SUCCESS_ACTION, payload: res.data.data });

      await localStorage.setItem("userData", JSON.stringify(res.data.data));
      console.log("**** login with goole appoinment_form ",appoinment_form)
      if (appoinment_form?.routing) {
        //await localStorage.setItem("userData", JSON.stringify(res.data.data));
        let doctrId = localStorage.getItem("doctrID");

        history.push(`/bookAppointment/${appoinment_form.doctorId}`);
      } else {
        //await localStorage.setItem("userData", JSON.stringify(res.data.data));
        history.push("/dashboard");
      }
      return res.data.data;
    }
    
    
    }
   
  };

export const updateLoginDetails = (data) => async (dispatch) => {
  dispatch({ type: UPDATE_LOGIN, payload: data });
};

export const validateresetPasswordKey = (key) => async (dispatch) => {
  const res = await loginedApi.post("getForgotPasswordUserDetails", {
    requestType: 12,
    token: hashcode.toString(),
    data: { key: key, isEncrypt: true },
  });

  console.log(res);

  if (res.data.data.info) {
    return { isSuccess: false, data: res.data.data.info };
  } else {
    return { isSuccess: true, data: res.data.data };
  }
  return res.data.data;
};
